"use client";
import {
  useCompositeGroupLabel
} from "../__chunks/ED7XMMMU.js";
import "../__chunks/TH2YTBRW.js";
import "../__chunks/3X3MDQGM.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/5M6RSQEC.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import "../__chunks/4R3V3JGP.js";

// src/select/select-group-label.ts
var TagName = "div";
var useSelectGroupLabel = createHook(
  function useSelectGroupLabel2(props) {
    props = useCompositeGroupLabel(props);
    return props;
  }
);
var SelectGroupLabel = forwardRef(function SelectGroupLabel2(props) {
  const htmlProps = useSelectGroupLabel(props);
  return createElement(TagName, htmlProps);
});
export {
  SelectGroupLabel,
  useSelectGroupLabel
};
